import { useState, useEffect } from "react";
import './Dashboard.css';
import Greeting from "../shared/Greeting";
import SummaryCards from "./sections/SummaryCards";
import QuickActions from "./sections/QuickActions";
import DiningGroups from "./sections/DiningGroups";
import DashboardNavbar from "../shared/DashboardNavbar";
import Footer from "../Footer/Footer";
import api from "../../Api/api";

function Dashboard() {
  
  const [summary, setSummary] = useState({
    MyExpenses: 0,
    MyGroups: 0,
    billsSplit: 0,
    MyDebts: 0
  });

  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const userEmail = currentUser?.email;
  

  //handle the expense
  const handleAddExpense = (newExpense) => {
    setSummary(prev => ({
      ...prev,
      MyExpenses: prev.MyExpenses + Number(newExpense.amount),
      billsSplit: prev.billsSplit + 1
    }));
  };
  //handle the group
  const handleAddGroup = (newGroup) => {
    setSummary(prev => ({
      ...prev,
      MyGroups: prev.MyGroups + 1
    }));
  };


  useEffect(() => {
    if (!userEmail) return;

    // 🧾 Fetch summary data from backend
    const fetchSummary = async () => {
      try {
        const [expenseRes, groupRes, debtRes] = await Promise.all([
          api.get('/dashboard/expenses'),
          api.get('/dashboard/groups'),
          api.get('/dashboard/debts')
        ]);

        console.log("Expenses response:", expenseRes.data);
        console.log("Groups response:", groupRes.data);
        console.log("Debts response:", debtRes.data);
        //convert to array if not already
        const expenses = Array.isArray(expenseRes.data.expenses) ? expenseRes.data.expenses : [];
        const groups = Array.isArray(groupRes.data.groups) ? groupRes.data.groups : [];
        const debts = Array.isArray(debtRes.data.debts) ? debtRes.data.debts : [];
        



        const totalExpenses = expenses
          //.filter(e => e.paidBy === userEmail)
          .reduce((sum, e) => sum + (Number(e.totalAmount) || 0), 0);

        const totalDebts = debts
          .filter(d => d.email === userEmail)
          .reduce((sum, d) => sum + (Number(d.amount) || 0), 0);

        setSummary({
          MyExpenses: totalExpenses,
          MyGroups: groups.length,
          billsSplit: expenses.length,
          MyDebts: totalDebts
        });

      } catch (err) {
        console.error("Dashboard API error:", err);
      }
    };

    fetchSummary();
  }, [userEmail]);



    return (
    <div className="dashboard-page">
      <div className="container mt-4">
        <DashboardNavbar />
                <Greeting />
                <QuickActions onAddExpense={handleAddExpense} onAddGroup={handleAddGroup} />

        <SummaryCards
          MyExpenses={summary.MyExpenses}
          MyGroups={summary.MyGroups}
          billsSplit={summary.billsSplit}
          MyDebts={summary.MyDebts}
        />
        
        <DiningGroups />
      </div>

      <Footer />
    </div>

  );
};
export default Dashboard;